import { render, staticRenderFns } from "./ProductsCarouselSection.vue?vue&type=template&id=280fd84e&scoped=true&"
import script from "./ProductsCarouselSection.vue?vue&type=script&lang=js&"
export * from "./ProductsCarouselSection.vue?vue&type=script&lang=js&"
import style0 from "./ProductsCarouselSection.vue?vue&type=style&index=0&id=280fd84e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280fd84e",
  null
  
)

export default component.exports